import { render } from "./ControlPanel.vue?vue&type=template&id=34ff38c4&scoped=true"
import script from "./ControlPanel.vue?vue&type=script&lang=js"
export * from "./ControlPanel.vue?vue&type=script&lang=js"

import "./ControlPanel.vue?vue&type=style&index=0&id=34ff38c4&scoped=true&lang=css"

import exportComponent from "/home/claude/weedborncounty/weedborncounty/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34ff38c4"]])

export default __exports__